'use client';
import { jsx, Fragment } from '@emotion/react/jsx-runtime';
import { Component } from 'react';

const initialState = {
    hasError: false,
    error: null
};
class ErrorBoundary extends Component {
    static getDerivedStateFromError(error) {
        return {
            hasError: true,
            error
        };
    }
    resetErrorBoundary() {
        if (this.state.error !== null) {
            var _this_props_onReset, _this_props;
            (_this_props_onReset = (_this_props = this.props).onReset) == null ? void 0 : _this_props_onReset.call(_this_props);
        }
        this.setState(initialState);
    }
    componentDidCatch(error, errorInfo) {
        var _this_props_onCatch, _this_props;
        (_this_props_onCatch = (_this_props = this.props).onCatch) == null ? void 0 : _this_props_onCatch.call(_this_props, error, errorInfo);
    }
    render() {
        const { children, renderFallback: RenderFallback } = this.props;
        const { hasError, error } = this.state;
        if (hasError) {
            return /*#__PURE__*/ jsx(RenderFallback, {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            });
        }
        return /*#__PURE__*/ jsx(Fragment, {
            children: children
        });
    }
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = initialState;
    }
}
var ErrorBoundary$1 = ErrorBoundary;

export { ErrorBoundary, ErrorBoundary$1 as default };
//# sourceMappingURL=ErrorBoundary.js.map
